// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"styles_sectionHeader__1b4YS","ornament":"styles_ornament__1z0Hg","texts":"styles_texts__25dX0","label":"styles_label__3sY5F","title":"styles_title__1fBgv"};